import React from "react";
import { SubTitle } from "@/components/pages/Community";
import { Stack, Unstable_Grid2 as Grid } from "@mui/material";
import styles from "./QuickLinksColumns.module.scss";

const QuickLinksColumns = ({ columns }) => (
  <Grid container spacing={4.5} sx={{ marginTop: 4, color: "#2b4d68" }}>
    {columns.map(({ title, links }) => (
      <Grid item key={title} xs={12} md={4} lg={3}>
        <SubTitle className={styles.columnTitle}>{title}</SubTitle>
        <Stack>
          {links.map((link) => (
            <a key={link.title} href={link.url} className={styles.columnLink}>
              {link.title}
            </a>
          ))}
        </Stack>
      </Grid>
    ))}
  </Grid>
);

export default QuickLinksColumns;
